import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import {Passageiro, PassageiroDeslocamento} from "./passageiro.model";
import {apiName, apiNamePassageirosDeslocamento} from "./data.service";

@Injectable()
export class PassageiroApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: Passageiro, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: Passageiro, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"nome","include":["endereco"]};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetAllActive(done: any) {
        let filter: any = {"where":{"ativo":true},"order":"nome","include":["endereco"]};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        let filter: any = {"include":["endereco"]};
        this._restService.onGetPostId(apiName, objectId, filter, done);
    }

    onGetApiUrl() {
        return apiName;
    }

    //passageiro deslocamento
    onPostPassageiroDeslocamento(object: PassageiroDeslocamento, done: any) {
        this._restService.onPost(apiNamePassageirosDeslocamento, object, done);
    }

    onPutPassageiroDeslocamento(object: PassageiroDeslocamento, done: any) {
        this._restService.onPut(apiNamePassageirosDeslocamento, object, done);
    }

    onDeletePassageiroDeslocamento(objectId: number, done: any) {
        this._restService.onDelete(apiNamePassageirosDeslocamento, objectId, done);
    }

    onGetPassageiroDeslocamento(filter: any, done: any) {
        filter.include = ["deslocamento","passageiro","pontoDeslocamentoEmbarque","pontoDeslocamentoDesembarque"];
        this._restService.onGetPost(apiNamePassageirosDeslocamento, filter, done);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/passageiros/shared/passageiro-api.service.ts
 **/